import React, { useEffect } from 'react';
import FeaturedCards from '../Common/Cards/FeaturedCards.js';
import ProductCards from '../Common/Cards/ProductCards';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProducts } from '../../Redux/ProductRedux';
import NewArrivalsCards from '../Common/Cards/NewArrivalsCards.js';

function Home() {
  const sectionName = 'home';
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allProducts } = useSelector((state) => state.productRedux);

  useEffect(() => {
    dispatch(getAllProducts()).catch((error) => {
      console.error('error', error);
    });
  }, [dispatch]);
  const handleViewProduct = () => {
    navigate('/products');
  };
  return (
    <div>
      <div className='my-5 p-3'>
        <div className='row d-flex align-items-center justify-content-center mb-4'>
          <div className='col-12 d-flex justify-content-center'>
            <p>Handpicked Favorites You’ll Love</p>
          </div>
          <div className='col-12 d-flex justify-content-center mb-2 '>
            <h3 className='underline'>Top Picks</h3>
          </div>
        </div>
        <div className='row d-flex align-items-center justify-content-center'>
          <FeaturedCards sectionName={sectionName} />
        </div>
      </div>
      <section className='container-fluid my-5'>
        <div className='my-5'>
          <div className='row d-flex align-items-center justify-content-center mb-4'>
            <div className='col-12 d-flex justify-content-center'>
              <p>Discover our latest</p>
            </div>
            <div className='col-12 d-flex justify-content-center mb-2 '>
              <h3 className='underline'>New Arrivals</h3>
            </div>
          </div>
          <div className='row d-flex align-items-center justify-content-center'>
            <NewArrivalsCards sectionName={sectionName} />
          </div>
        </div>

        <div className='my-5'>
          <div className='row d-flex align-items-center justify-content-center mb-4'>
            <div className='col-12 d-flex justify-content-center'>
              <p>Explore our diverse collection of</p>
            </div>
            <div className='col-12 d-flex justify-content-center mb-2 '>
              <h3 className='underline'>Products</h3>
            </div>
          </div>
          <div className='row d-flex align-items-center justify-content-center'>
            <ProductCards
              sectionName={sectionName}
              allProducts={allProducts}
            />
          </div>
          <div className='d-flex justify-content-center'>
            <Button
              className='m-3'
              color='success'
              variant='outlined'
              onClick={handleViewProduct}
            >
              View More
            </Button>
          </div>
        </div>

        {/* <div className='my-5'>
          <div className='row d-flex align-items-center justify-content-center mb-4'>
            <div className='col-12 d-flex justify-content-center'>
              <p>Read our</p>
            </div>
            <div className='col-12 d-flex justify-content-center mb-2 '>
              <h3 className='underline'>News and Events</h3>
            </div>
          </div>
          <div className='row d-flex align-items-center justify-content-center'>
            <NewsCards sectionName={sectionName} newsEvents={newsEvents} />
          </div>
        </div> */}
      </section>
    </div>
  );
}

export default Home;
